import { Select, SelectProps } from 'antd';
import uniqBy from 'lodash/uniqBy';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RoleType, RolesOption } from './types';

interface RoleSelectorProps extends SelectProps {
  rolesOption: RolesOption[];
  defaultRoleType?: number;
  onChange?: (value: number) => void;
  useAllType?: boolean;
}

export const RoleSelector = (props: RoleSelectorProps) => {
  const { t } = useTranslation();
  const { rolesOption, defaultRoleType, onChange, useAllType = false, ...restProps } = props;
  const [role, setRole] = React.useState<number | undefined>(defaultRoleType);
  const allTypeOption = {
    value: RoleType.All,
    label: t('所有成员'),
  };
  const selectOptions = [...rolesOption];
  if (useAllType) {
    selectOptions.unshift(allTypeOption);
  }

  const onRoleChange = (role: number) => {
    setRole(role);
    onChange?.(role);
  };

  useEffect(() => {
    setRole(defaultRoleType);
  }, [defaultRoleType]);

  return (
    <Select
      value={role}
      options={uniqBy(selectOptions, 'value')}
      onChange={onRoleChange}
      placeholder={t('请选择')}
      {...restProps}
    />
  );
};
